import React from 'react';

class Title extends React.PureComponent {
  componentDidMount() {

  }
  render() {
    return (
      <div className="main-title">
        
        <h1><span className="transition-inline-element">Mentions </span> <strong className="transition-inline-element">légales</strong></h1>
        <small className="label-jp transition-inline-element--jp" lang="ja">法的通知</small> 
      </div>
    )
  }

}

export default Title;